import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, MessageSquare, MapPin, MessageCircle, Search, Globe, PhoneMissed, Users } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Google Review Generation',
    description: 'Automated systems to request and capture reviews from happy customers.',
    icon: Star
  }, {
    title: 'SMS/Email Automation',
    description: 'Smart follow-up sequences that convert customers into vocal advocates.',
    icon: MessageSquare
  }, {
    title: 'GBP Optimization',
    description: 'Fully optimized Google Business Profile to rank higher in local searches.',
    icon: MapPin
  }, {
    title: 'Review Responses',
    description: 'Professional, timely responses to all reviews to show you care.',
    icon: MessageCircle
  }, {
    title: 'Local SEO',
    description: 'Comprehensive strategies to dominate the local map pack and search results.',
    icon: Search
  }, {
    title: 'Website Setup',
    description: 'High-converting, mobile-responsive websites built for local businesses.',
    icon: Globe
  }, {
    title: 'Missed-Call Text Back',
    description: "Never lose a lead. Instantly text back callers when you can't answer.",
    icon: PhoneMissed
  }, {
    title: 'Reactivation Campaigns',
    description: 'Bring past customers back with targeted SMS and email offers.',
    icon: Users
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="services" className="py-20 md:py-32 bg-white" data-id="element-304">
      <div className="container mx-auto px-4 md:px-6" data-id="element-305">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-306">
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-navy mb-4" data-id="element-307">
            Helping Local Businesses Get Found & Trusted
          </h2>
          <p className="text-lg text-muted" data-id="element-308">
            We provide a complete suite of local growth services designed to
            build your reputation and drive more calls to your business.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-309">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} variants={itemVariants} whileHover="hover" className="relative bg-white rounded-xl p-6 border border-gray-100 shadow-card hover:shadow-card-hover transition-shadow overflow-hidden group" data-id="element-310">
                {/* Animated Left Border on Hover */}
                <motion.div className="absolute left-0 top-0 bottom-0 w-1 bg-gold origin-left" initial={{
              scaleY: 0
            }} variants={{
              hover: {
                scaleY: 1
              }
            }} transition={{
              duration: 0.2
            }} data-id="element-311" />

                <div className="w-12 h-12 rounded-full bg-gold-soft flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300" data-id="element-312">
                  <Icon className="w-6 h-6 text-navy" data-id="element-313" />
                </div>

                <h3 className="text-xl font-heading font-bold text-navy mb-2" data-id="element-314">
                  {service.title}
                </h3>
                <p className="text-muted text-sm leading-relaxed" data-id="element-315">
                  {service.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}